import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtilService } from '../service/common-util.service';

@Component({
  selector: 'app-rpost-sso-logout',
  templateUrl: './rpost-sso-logout.component.html',
  styleUrls: ['./rpost-sso-logout.component.css']
})
export class RpostSsoLogoutComponent implements OnInit {
  logoutCallBakcUrl:any;
  constructor(private router: Router,private route: ActivatedRoute,private commonUtilSvc: CommonUtilService) {
    this.route.queryParams.subscribe( params => this.logoutCallBakcUrl=params['logoutcallbackurl']);
  }
  ngOnInit(): void {
    this.commonUtilSvc.clearMSALLocalStorage();
    this.commonUtilSvc.clearMSALSessionStorage();
    // Introduce a delay before navigating to the final returnUrl
    setTimeout(() => {
      //const returnUrl = localStorage.getItem('postLogoutRedirect'); 
      // Retrieve the original returnUrl
      if (this.logoutCallBakcUrl!=null && this.logoutCallBakcUrl!=undefined && this.logoutCallBakcUrl.length>0) {
        //localStorage.removeItem('postLogoutRedirect');
          window.location.href = this.logoutCallBakcUrl!; // Perform the final redirect     
         } 
         else {
          this.router.navigate(['/errorpage']); // Default redirect if returnUrl is not found
         }
      }, 5000); // 5 secs
    }

  }




